export default __webpack_public_path__ + "static/media/Rachel_West.cf34ca9e.jpeg";